"use client"

import { startTransition, useEffect } from "react"
import { useRouter } from "next/navigation"
import { useTranslations } from "next-intl"
import { MaintenanceScreen } from "@/components/maintenance-screen"

// Shown when anything inside a page throws. The header/nav stay intact because
// this renders inside the root layout; a crash of the layout itself is handled
// by global-error.tsx.
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations("maintenanceScreen")
  const router = useRouter()

  useEffect(() => {
    console.error("[error-boundary]", error)
  }, [error])

  // Most real failures happen while the server renders the page (e.g. a database
  // hiccup). reset() alone only re-renders the browser's copy of that failure, so
  // also ask the server for a fresh render.
  const retry = () => {
    startTransition(() => {
      router.refresh()
      reset()
    })
  }

  return (
    <MaintenanceScreen
      title={t("title")}
      body={t("body")}
      retryLabel={t("tryAgain")}
      homeLabel={t("backToHome")}
      helpLabel={t("stillStuck")}
      referenceLabel={t("reference")}
      digest={error.digest}
      onRetry={retry}
    />
  )
}
